export default __webpack_public_path__ + "static/media/loading.8f0c8708.svg";